/* eslint-disable no-param-reassign */

/* eslint-disable no-plusplus */

/* eslint-disable radix */
import { isValid, parseISO } from 'date-fns';
import { normalizers } from '..';

export const validateNomeSegurado = (value) => {
  return /^([A-ZÀ-Ú][a-zà-ú]{2,50})((\s[d][a|e|i|o|u])?\s[A-ZÀ-Ú][a-zà-ú]{2,50})+$/.test(
    value,
  );
};

export const validateCompare = (valueToCompare) => (value) => {
  if (!value || !valueToCompare) return false;
  return valueToCompare === value;
};

export const validateCPF = (strCPF) => {
  strCPF = strCPF.replace(/[^\d]+/g, '');
  let Soma;
  let Resto;
  Soma = 0;
  if (
    strCPF === '00000000000' ||
    strCPF === '11111111111' ||
    strCPF === '22222222222' ||
    strCPF === '33333333333' ||
    strCPF === '44444444444' ||
    strCPF === '55555555555' ||
    strCPF === '66666666666' ||
    strCPF === '77777777777' ||
    strCPF === '88888888888' ||
    strCPF === '99999999999'
  )
    return false;
  for (let i = 1; i <= 9; i++)
    Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;
  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(9, 10))) return false;
  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;
  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
  return true;
};

const CNPJ_REGEX = /^[A-Z0-9]{12}\d{2}$/;
const CNPJ_ZERADO = '00000000000000';
const CNPJ_DV_PESOS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const calculaDvCnpj = (base12) => {
  let somatorioDV1 = 0;
  let somatorioDV2 = 0;

  for (let i = 0; i < 12; i++) {
    const asciiDigito = base12.charCodeAt(i) - 48;
    somatorioDV1 += asciiDigito * CNPJ_DV_PESOS[i + 1];
    somatorioDV2 += asciiDigito * CNPJ_DV_PESOS[i];
  }

  const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
  somatorioDV2 += dv1 * CNPJ_DV_PESOS[12];
  const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

  return `${dv1}${dv2}`;
};

export function validateCNPJ(cnpj) {
  if (!cnpj) return false;

  const stripped = cnpj.replace(/[.\-/]/g, '').toUpperCase();

  if (!CNPJ_REGEX.test(stripped) || stripped === CNPJ_ZERADO) {
    return false;
  }

  if (/^\d+$/.test(stripped) && /^(\d)\1+$/.test(stripped)) {
    return false;
  }

  const dvInformado = stripped.substring(12);
  const dvCalculado = calculaDvCnpj(stripped.substring(0, 12));

  return dvInformado === dvCalculado;
}

export const validateCPFAndCNPJ = (strCpfCnpj) => {
  if (!strCpfCnpj) return false;

  const raw = strCpfCnpj.replace(/[.\-/\s]/g, '').toUpperCase();

  if (raw.length <= 11) {
    return validateCPF(strCpfCnpj);
  }

  return validateCNPJ(strCpfCnpj);
};

export async function validateCEP(cep) {
  const filteredCEP = normalizers.onlyNums(cep);

  if (filteredCEP && filteredCEP.length < 8) {
    return false;
  }
  return true;
}

export async function validatePhone(phone) {
  const filteredPhone = normalizers.onlyNums(phone);

  if (filteredPhone && filteredPhone.length < 10) {
    return false;
  }
  return true;
}

export async function validateCellPhone(phone) {
  const filteredPhone = normalizers.onlyNums(phone);
  let onlySameNumber = true;

  // Nao permite numeros iguais ex: 111111111
  for (let i = 3; i < filteredPhone.length; i++) {
    if (filteredPhone.charAt(i) !== filteredPhone.charAt(i - 1)) {
      onlySameNumber = false;
    }
  }

  if ((filteredPhone && filteredPhone.length < 11) || onlySameNumber) {
    return false;
  }
  return true;
}

export async function validateDate(date) {
  if (date) {
    const parsedDate = parseISO(date.split('/').reverse().join('-'));
    const validDate = isValid(parsedDate);

    if (validDate === false) {
      window.scrollTo({
        top: 100,
        behavior: 'smooth',
      });
    }

    const dtBir = new Date(parsedDate);
    const dtNow = new Date();

    const a = dtNow.getFullYear();
    const b = dtBir.getFullYear();

    const isDiff = a - b >= 18 && a - b <= 100;

    if (!isDiff) {
      window.scrollTo({
        top: 100,
        behavior: 'smooth',
      });
    }

    return isDiff;
  }
  window.scrollTo({
    top: 100,
    behavior: 'smooth',
  });
  return false;
}

export async function validateCompanyDate(date) {
  if (date) {
    const parsedDate = parseISO(date.split('/').reverse().join('-'));
    const validDate = isValid(parsedDate);

    if (validDate === false) {
      window.scrollTo({
        top: 100,
        behavior: 'smooth',
      });
    }

    const dtBir = new Date(parsedDate);
    const dtNow = new Date();

    const a = dtNow.getFullYear();
    const b = dtBir.getFullYear();

    const isDiff = a - b >= 0 && a - b <= 1000;

    if (!isDiff) {
      window.scrollTo({
        top: 100,
        behavior: 'smooth',
      });
    }

    return isDiff;
  }
  window.scrollTo({
    top: 100,
    behavior: 'smooth',
  });
  return false;
}

export const isValidToken = (token) => {
  const tokenPattern = /^(?!\s*$).+$/;
  return tokenPattern.test(token);
};
